document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (e){
        var linkElem = e.target.closest('span.js-link')
        if (!linkElem) return
        var link = linkElem.getAttribute('data-link')
        window.open(window.location.origin+link, '_blank')
    })
})
